import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=1cbc64ec&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Options.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbc64ec')) {
      api.createRecord('1cbc64ec', component.options)
    } else {
      api.reload('1cbc64ec', component.options)
    }
    module.hot.accept("./Options.vue?vue&type=template&id=1cbc64ec&", function () {
      api.rerender('1cbc64ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/Options.vue"
export default component.exports